import { useEffect, useState } from 'react';
import axios from 'axios'
import Payment from '../components/Payment'
import io from 'socket.io-client';
import '../styles/main.css'
import Table from '../components/Table'
import NewGameModal from '../components/NewGameModal';
import NewPlayerModal from '../components/NewPlayerModal';
import Buyins from '../components/Buyins';
import PieChart from '../components/PieChart';
import LineChart from '../components/LineChart';
import Navbar from '../components/Navbar';
import { Button } from 'react-bootstrap';
import '../styles/payment.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrophy, faUser, faEnvelope } from '@fortawesome/free-solid-svg-icons'

function Main() {
    const [tableRowsData, setTableRowsData] = useState([])
    const [selectGameName, setSelectGameName] = useState('');
    const [gamesList, setGamesList] = useState([])
    const [paymentValue, setPaymentvalue] = useState(0);
    const [isPlus, setIsPlus] = useState(true);
    const [isNewGameModalOpen, setIsNewGameModalOpen] = useState(false);
    const [isNewPlayerModalOpen, setIsNewPlayerModalOpen] = useState(false);
    const [buyinsList, setBuyinsList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem('token');


    useEffect(() => {
        fetchGamesNames()
    }, [])

    useEffect(() => {
        const socket = io('https://kaskas.pro', { path: '/socket.io/' }); 
        socket.on('updatedData', (data) => {
            setTableRowsData(prevData => {
                if (prevData.gameID === data.gameID) {
                    return data
                }
                return prevData;
            });
        });

        socket.on('addedNewPlayer', (data) => {
            if (tableRowsData.gameID !== data.gameID) return;
            setTableRowsData(prevData => {
                return {
                    ...prevData,
                    players: [...prevData.players, data.newPlayer]
                };
            });
        });
        socket.on('addedNewGame', (data) => {
            setTableRowsData(data.newGame);
        });

        fetchGamesNames();

        return () => {
            socket.disconnect();
        };
    }, [tableRowsData]);

    useEffect(() => {
        if (selectGameName === '') return;
        axios.get(`https://kaskas.pro/poker-stats-server/api/api/getGameByName/${selectGameName}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setTableRowsData(response.data);
        }).catch(err => { alert(`Error fetching data:${err}`) })
    }, [selectGameName])



    const handleGameNameChange = (e) => {
        let value = e.target.value
        setSelectGameName(value);
    }

    const updateTableDataInParent = (newData) => {
        newData.sort((a, b) => b.buyinAmount - a.buyinAmount)

        setTableRowsData(prevData => ({
            ...prevData,
            players: newData
        }));
    }

    function fetchGamesNames() {
        axios.get(`https://kaskas.pro/poker-stats-server/api/api/getGamesNames`, {
            headers: {
                Authorization: `Bearer ${token}` // Include the JWT token in the Authorization header
            }
        }).then(response => {
            setGamesList(response.data)
            if (!selectGameName)
                setSelectGameName(response.data ? response.data[0] : [])
            setIsLoading(false);

        }).catch(err => {
            alert(`Error fetching data:${err}`)
        })
    }

    function updateRowRequest(gameID, player, amount, isBuyin) {
        console.log(player)
        axios.post(`https://kaskas.pro/poker-stats-server/api/api/updateBuyin/`, { gameID, updatedPlayerData: player, amount, isBuyin }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
        }).catch(err => {
            alert(`Error fetching data:${err}`)
        })
    }

    const updatePaymentValue = (value) => {
        setPaymentvalue(value);
    }

    const updateIsPlus = (value) => {
        setIsPlus(value);
    }

    const updateParentSelectedGame = (newGameName) => {
        setSelectGameName(newGameName);
    }

    const updatedBuyinsList = (newData) => {
        setBuyinsList(newData);
    };

    const sendMail = () => {
        axios.post(`https://kaskas.pro/poker-stats-server/api/api/sendMail`, { gameName: selectGameName, gameData: JSON.stringify(tableRowsData) },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            console.log(response.data);
        }).catch(err => {
            alert(err)
        })
    }
    return (
        <>
            {isLoading ? <div className='loaderWrapper'><div className='loader'></div></div> :
                <>
                    <Navbar selectedItem={'game'} />
                    <div className='sidesContainer'>
                        <div className='leftSideContainer'>
                            <Table playersData={tableRowsData} updateTableDataInParent={updateTableDataInParent} updateRowRequest={updateRowRequest} paymentValue={paymentValue} isPlus={isPlus} />
                        </div>
                        <div className='rightSideContainer'>
                            <div className='gameControlBtnsContainer'>
                                <Button variant='success' className='gameControlBtns' onClick={() => setIsNewGameModalOpen(true)}>משחק חדש <FontAwesomeIcon icon={faTrophy} /></Button>
                                <Button variant='success' className='gameControlBtns' onClick={() => setIsNewPlayerModalOpen(true)}>הוספת שחקן <FontAwesomeIcon icon={faUser} /></Button>
                                <Button variant='success' className='gameControlBtns' onClick={() => sendMail()}>עדכון למייל <FontAwesomeIcon icon={faEnvelope} /></Button>
                            </div>
                            <div className='gamepickerContainer'>
                                <select value={selectGameName} onChange={handleGameNameChange}>
                                    {gamesList.map((gameName, index) => (
                                        <option key={index} value={gameName}>{gameName}</option>
                                    )
                                    )}
                                </select>
                            </div>
                            <Payment playersData={tableRowsData} updateTableDataInParent={updateTableDataInParent} updateRowRequest={updateRowRequest} updateParentPaymentValue={updatePaymentValue} updateParentIsPlus={updateIsPlus} />
                        </div>
                    </div>
                    <NewGameModal isOpen={isNewGameModalOpen} onRequestClose={() => setIsNewGameModalOpen(false)} updateParentSelectedGame={updateParentSelectedGame} fetchGamesNames={fetchGamesNames} />
                    <NewPlayerModal isOpen={isNewPlayerModalOpen} onRequestClose={() => setIsNewPlayerModalOpen(false)} gameID={tableRowsData.gameID} />
                    <div className='bottomContainer'>
                        <PieChart tableRowsData={tableRowsData} />
                        <LineChart buyinsList={buyinsList} />
                        <Buyins gameID={tableRowsData.gameID} updateParentSelectedGame={updateParentSelectedGame} fetchGamesNames={fetchGamesNames} buyinsList={buyinsList} updatedBuyinsList={updatedBuyinsList} />
                    </div>
                </>}
        </>
    )
}

export default Main